import $ from 'jquery'

export default () => {
    $('a[href*="#"].scroll-down').on('click', function (el) {
        el.preventDefault()

        $('html, body').animate({
            scrollTop: $($(this).attr('href')).offset().top
        }, 500, 'linear')
    })
}
